import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import "pages/style.css"

export function AddInspector() {
    let history = useHistory();
    const [formValue, setformValue] = useState({
        name: "",
        surname: "",
        lastname: ""
    });
    const url = "/api/add/inspector"
    const handleSubmit = (event) => {
        event.preventDefault();
        try {
            axios.post(url, { name: formValue.name, surname: formValue.surname, lastname: formValue.lastname })
        } catch (error) {
            console.log(error)
        }
        history.goBack()
    }
    const handleChange = (event) => {
        setformValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    }
    return (
        <div className="main">
            <h2>Добавить инспектора</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    Имя:
                    <br />
                    <input type="text" name="name" value={formValue.name} onChange={handleChange}></input>
                    <br />
                    Фамилия:
                    <br />
                    <input type="text" name="lastname" value={formValue.lastname} onChange={handleChange}></input>
                    <br />
                    Отчество:
                    <br />
                    <input type="text" name="surname" value={formValue.surname} onChange={handleChange}></input>
                    <br />
                </label>
                <br />
                <input type={"submit"} value={"Отправить"} />
                <input type={"button"} value={"Назад"} onClick={history.goBack} />
            </form>
        </div>
    )
}